import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseButton, useAuth, useLoginRequiredModal, useT } from '@repo/common';
import ResumeRow from './ResumeRow';

import { ReactComponent as ReloadIcon } from '@repo/common/assets/icons/16px/icon_16px_reload.svg';
import { ReactComponent as InfoIcon } from '@repo/common/assets/icons/20px/icon_20px_info_filled.svg';

import { getAllCareers } from '../../../api/career/career.api';

const Resume = ({
  selectedResume,
  onChangeResume,
  submitAttempted,
  status,
  $isMobile,
}) => {
  const t = useT();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { showLoginModal } = useLoginRequiredModal();
  const [resumeData, setResumeData] = useState(null);

  const fetchCareers = async () => {
    try {
      const data = await getAllCareers();
      setResumeData(data);
    } catch (e) {
      console.error(e);
      setResumeData([]);
    }
  };

  useEffect(() => {
    if (status !== 'view') fetchCareers();
  }, [status]);

  const handleCreateResume = () => {
    if (!isLoggedIn) {
      showLoginModal('jobboard_create_resume_cta');
      return;
    }
    navigate('/career');
  };

  const standardResume = Array.isArray(resumeData)
    ? resumeData.find((resume) => resume.standard === true)
    : null;
  const resumeToShow = status === 'view' ? selectedResume : selectedResume ?? standardResume;
  const hasResume = !!resumeToShow;

  return (
    <div className='flex flex-col items-start tabletH:py-6'>
      <div className='flex flex-col w-full'>
        <div className='flex pb-2 justify-between items-center w-full'>
          <div className='typo-b14Strong tabletH:typo-b16Strong text-text-primary'>
            {t('Resume', '이력서')}
          </div>

          {status === 'edit' && (
            <BaseButton
              type='text'
              size='s'
              typo={false}
              isStatic
              icon={<ReloadIcon />}
              gap='gap-0.5 tabletH:gap-1'
              textWrapperClass='mt-0.5 h-auto flex-none'
              className='h-auto min-w-0 cursor-pointer rounded-none border-0 bg-transparent py-0 px-1 tabletH:px-0 typo-b12Strong text-text-secondary hover:text-text-placeholder'
              onClick={onChangeResume}
            >
              {t('Change resume', '이력서 변경')}
            </BaseButton>
          )}
        </div>
        {submitAttempted && !hasResume && (
          <div className='flex items-start pb-2 gap-1 text-text-failed typo-b14Strong'>
            <InfoIcon />
            <span className='mt-[1px]'>
              {t(
                'You need to create a resume before applying',
                '지원하려면 먼저 이력서를 작성해야 합니다',
              )}
            </span>
          </div>
        )}
      </div>

      {!hasResume && status === 'view' ? (
        <p className='typo-b14 text-text-secondary'>{t('The submitted resume is unavailable.', '제출 이력서를 확인할 수 없습니다.')}</p>
      ) : !hasResume ? (
        <div className='w-full bg-grayscale-gray00 rounded-lg border border-grayscale-gray03'>
          <div className='flex flex-col items-center justify-center px-6 gap-2 h-[114px]'>
            <div className='typo-b14Strong text-text-secondary'>
              {t('You don’t have a resume yet', '아직 이력서가 없습니다')}
            </div>
            <BaseButton
              type='secondary'
              hideIcon
              size='s'
              onClick={handleCreateResume}
            >
              {t('Create resume', '이력서 만들기')}
            </BaseButton>
          </div>
        </div>
      ) : (
        resumeToShow && (
          <ResumeRow
            resume={resumeToShow}
            status={status}
            isMyPage
            $isMobile={$isMobile}
          />
        )
      )}
    </div>
  );
};

export default Resume;
